import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import moment from 'moment-timezone';

import { openModal } from 'actions/modalActions';
import { updateCongratsStatus } from 'actions/userActions';
import { USER_ROLE } from 'config/constants';

import Logout from '../../auth/Logout/Logout';
import NavDropdownItem from '../NavDropdownItem/NavDropdownItem';
import NavLink from '../NavLink/NavLink';
import SignUpStep from '../../SignUpStep';

import './MainNavbar.css';

class MainNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = { currentTime: moment().format('h:mm A') };
    this.clockTimer = setInterval(this.tick.bind(this), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.clockTimer);
  }

  tick = () => {
    const time = moment().format('h:mm A');
    this.setState({ currentTime: time });
  };

  isAuthenticated = () => {
    const { reauthenticateStatus, user } = this.props;

    return user.profile.role === USER_ROLE.TEACHER || user.profile.role === USER_ROLE.ADMIN ?
      reauthenticateStatus === 'SUCCESS' ||
          (reauthenticateStatus === 'INIT' && user.token) :
      user.token && user.profile.activate && user.profile.onboard;
  };

  handleLogin = (event) => {
    event.preventDefault();
    this.props.openModal('login-modal');
  };

  handleSignUp = (event) => {
    event.preventDefault();
    this.props.openModal('signup-modal');
  };

  handleClickMenuItem = (url) => {
    return (event) => {
      event.preventDefault();

      const { user, updateCongratsStatus: updateCongratsStatusFn } = this.props;
      if (user.congratsStatus === 'PENDING') {
        updateCongratsStatusFn('DONE');
      }

      browserHistory.push(url);
    };
  };

  renderPromoSpot() {
    const { user } = this.props;
    const items = [];
    if (user.profile.trialStatus.status === 'credit_trial') {
      const promoCode = user.profile.trialStatus.trialUpgradePromoCode;
      const path = promoCode ?
        `/activate?promo=${promoCode}&src=navBarWithPromo` :
        '/activate?src=navBar';

      if (user.profile.trialStatus.promoExpiresAt) {
        const promoExpiresAt = moment.utc(
          user.profile.trialStatus.promoExpiresAt
        );
        const isToday = promoExpiresAt.isSame(moment(), 'day');
        const expiresString = isToday ?
          'Join today for $30 off your first month' :
          `Join before
        ${promoExpiresAt.format('MMM D')} for $40 off your first month`;

        items.push(
          <li className="nav-item hidden-sm-down" key="main-nav-promo-expire">
            <a href={path} className="nav-link">
              <strong>{expiresString}</strong>
            </a>
          </li>
        );
      }

      items.push(
        <li className="nav-item hidden-sm-down" key="main-nav-promo-join">
          <a
            className="referral-link btn btn-sm btn-primary"
            href={path}
            target="_blank"
            rel="noopener noreferrer"
          >
            Join
          </a>
        </li>
      );
    } else {
      items.push(
        <li className="nav-item hidden-sm-down" key="main-nav-refer">
          {/* <a
            className="referral-link btn btn-sm btn-primary"
            href="https://www.rypeapp.com/refer/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get $70
          </a> */}
        </li>
      );
    }
    return items;
  }

  renderRightNavbarLinks() {
    const { user } = this.props;
    const isPaused = !!user.profile.pause;

    if (this.isAuthenticated() && user.profile.role === USER_ROLE.TEACHER) {
      return (
        <Logout className="hidden-sm-down d-flex align-items-center justify-content-center" />
      );
    }

    if (this.isAuthenticated() && !isPaused) {
      return [
        ...this.renderPromoSpot(),
        <li className="nav-item hidden-sm-down" key="main-nav-time">
          <a className="nav-link">{this.state.currentTime}</a>
        </li>,
        <li
          className="nav-item dropdown hidden-sm-down"
          key="main-nav-dropdown"
        >
          <a
            className="nav-link dropdown-toggle"
            id="profile-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            role="button"
          >
            {user.profile.givenName || 'Profile'}
          </a>

          <div className="dropdown-menu" aria-labelledby="profile-dropdown">
            <NavDropdownItem
              key="main-nav-edit-profile"
              to="/profile/edit"
              onClick={this.handleClickMenuItem('/profile/edit')}
              data-qa-id="edit-profile-menu-item"
            >
              Edit Profile
            </NavDropdownItem>

            <div className="dropdown-divider" />

            <NavDropdownItem
              to="/profile/plans-and-billing"
              key="main-nav-pause-cancel"
              onClick={this.handleClickMenuItem('/profile/plans-and-billing')}
            >
              Plans & Billing
            </NavDropdownItem>

            <div className="dropdown-divider" />

            <NavDropdownItem key="main-nav-feedback" to="/feedback">
              Feedback
            </NavDropdownItem>

            <div className="dropdown-divider" />

            <a
              className="dropdown-item"
              key="main-nav-problem"
              href="/report-problem"
              rel="noopener noreferrer"
            >
              Report Problem
            </a>

            <div className="dropdown-divider" />

            <a
              className="dropdown-item"
              key="main-nav-help"
              href="https://help.rypeapp.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help
            </a>

            <div className="dropdown-divider" />

            <Logout className="dropdown-item" />
          </div>
        </li>,
      ];
    }

    if (
      !this.isAuthenticated() &&
      this.props.location.pathname.indexOf('schedule-lesson') !== -1
    ) {
      return [
        <li className="nav-item" key="main-nav-login">
          <NavLink to="/login" onClick={this.handleLogin} data-qa-id="login-button">
            Login
          </NavLink>
        </li>,
        <li className="nav-item hidden-sm-down" key="main-nav-try-free">
          <a
            className="referral-link btn btn-sm btn-primary"
            href="/register"
            onClick={this.handleSignUp}
            data-qa-id="signup-button"
          >
            Sign Up
          </a>
        </li>,
      ];
    }

    return null;
  }

  renderLeftNavbarLinks() {
    const { user } = this.props;
    const isPaused = !!user.profile.pause;

    if (this.isAuthenticated() && user.profile.role === USER_ROLE.TEACHER) {
      return (
        <div className="hidden-md-up" key="main-nav-teacher-profile-xs">
          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-home-xs">
            <NavLink to="/teacher/home">Home</NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-reservation-xs">
            <NavLink to="/teacher/schedule/reservations">Reservations</NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-availability-xs">
            <NavLink to="/teacher/schedule/availability">Availability</NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-listing-xs">
            <NavLink to="/teacher/schedule/listings">Listing</NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-setting-xs">
            <NavLink to="/teacher/settings">Settings</NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-teacher-logout-xs">
            <Logout className="nav-link" />
          </li>
        </div>
      );
    }

    if (this.isAuthenticated() && !isPaused) {
      return [
        <li className="nav-item hidden-md-up" key="main-nav-time-xs">
          <a className="nav-link">{moment().format('hh:mm A')}</a>
        </li>,
        <li className="nav-item" key="main-nav-schedule-lesson">
          <NavLink
            to="/schedule-lesson"
            onClick={this.handleClickMenuItem('/schedule-lesson')}
          >
            Schedule
          </NavLink>
        </li>,

        <li className="divider" key="main-nav-divider">
          <hr />
        </li>,

        <li className="nav-item" key="main-nav-reservations">
          <NavLink
            to="/reservations"
            onClick={this.handleClickMenuItem('/reservations')}
          >
            Reservations
          </NavLink>
        </li>,

        <div className="hidden-md-up" key="main-nav-profile-xs">
          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-edit-profile-xs">
            <NavLink
              to="/profile/edit"
              onClick={this.handleClickMenuItem('/profile/edit')}
            >
              Edit Profile
            </NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-pause-cancel-xs">
            <NavLink
              to="/profile/plans-and-billing"
              onClick={this.handleClickMenuItem('/profile/plans-and-billing')}
            >
              Plans & Billing
            </NavLink>
          </li>

          {/* <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-refer-xs">
            <a
              className="nav-link"
              href="https://www.rypeapp.com/refer/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get $70
            </a>
          </li> */}

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-feedback-xs">
            <NavLink
              to="/feedback"
              onClick={this.handleClickMenuItem('/feedback')}
            >
              Feedback
            </NavLink>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-problem-xs">
            <a
              className="nav-link"
              href="/report-problem"
              rel="noopener noreferrer"
            >
              Report Problem
            </a>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-help-xs">
            <a
              className="nav-link"
              href="https://help.rypeapp.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help
            </a>
          </li>

          <li className="divider">
            <hr />
          </li>

          <li className="nav-item " key="main-nav-logout-xs">
            <Logout className="nav-link" />
          </li>
        </div>,
      ];
    }

    return null;
  }

  renderNav() {
    const { signUpStepIndex, user } = this.props;

    return (
      <div className="MainNavbar">
        <nav
          className={classnames(
            'navbar navbar-toggleable-sm fixed-top navbar-light',
            {
              'bg-white': !(signUpStepIndex === 2),
              'md-bg-white': signUpStepIndex === 2,
              'teacher-dashboard':
                this.props.user.profile.role === USER_ROLE.TEACHER,
            }
          )}
        >
          <button
            className="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#main-navbar"
            aria-controls="main-navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <span className="navbar-brand text-primary py-0">
            <img
              className="navbar-brand-logo"
              src="/assets/rype-logo-black.png"
              alt="logo"
            />
          </span>

          <div
            className="collapse navbar-collapse pb-1 pb-md-0"
            id="main-navbar"
          >
            <ul className="navbar-nav mr-auto mt-2 mt-sm-0">
              {this.renderLeftNavbarLinks()}
            </ul>

            <ul className="navbar-nav">{this.renderRightNavbarLinks()}</ul>

            {!this.isAuthenticated() && (
              <div className="navbar-intercom-link">
                Need help?{' '}
                <a
                  href="https://www.rypeapp.com/faq/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Read our FAQ
                </a>
              </div>
            )}
          </div>

          {signUpStepIndex && signUpStepIndex !== 2 && (
            <div className="navbar-steps d-flex align-items-center justify-content-center">
              <SignUpStep currentStep={signUpStepIndex} />
            </div>
          )}
        </nav>
      </div>
    );
  }

  render() {
    // const isOnActivate = location.pathname.indexOf('/activate') !== -1;

    return <div>{this.renderNav()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    reauthenticateStatus: state.user.reauthenticateStatus,
  };
}

export default withRouter(
  connect(mapStateToProps, { openModal, updateCongratsStatus })(MainNavbar)
);



// WEBPACK FOOTER //
// ./src/components/navigation/MainNavbar/MainNavbar.js